import { useQuery } from '@tanstack/react-query';
// Service
import { getContentType, getAllContentTypes } from './contentTypeService';

/**
 * @description useQuery Hook to get a content type by its ID.
 * @param {string} contentTypeId
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<
 * ContentType, Error>}
 */
export const useGetContentTypeQuery = (contentTypeId, options) => useQuery({
  queryKey: ['contentType', contentTypeId],
  queryFn: () => getContentType(contentTypeId),
  ...options,
});

/**
 * @description useQuery Hook to get all content types.
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<
 * {data: ContentType[]}, Error>}
 */
export const useGetAllContentTypesQuery = (options) => useQuery({
  queryKey: ['all-contentTypes'],
  queryFn: () => getAllContentTypes(),
  ...options,
});
